import { jsx } from '@emotion/core';
import { facepaintMediaQueries } from '../shared';
import { GRID } from '../../constants';

var styles = function styles(prioritize) {
  var prioritizeFirst = prioritize === 'first';
  return [facepaintMediaQueries({
    display: ['block', 'grid'],
    gridGap: [GRID.xsmall, GRID.xsmall, GRID.small],
    gridTemplateAreas: [null, prioritizeFirst ? "\"one one\" \"two three\"" : "\"one two\" \"three three\"", '"one two three"'],
    gridTemplateColumns: ['1fr', '1fr 1fr', '1fr 1fr 1fr'],
    justifyContent: 'stretch',
    marginTop: [GRID.small, GRID.small, GRID.large],
    marginBottom: [GRID.xsmall, GRID.xsmall, GRID.small],
    boxSizing: 'border-box',
    '> *': {
      marginBottom: [GRID.xsmall, 0]
    },
    '& > :nth-child(1)': {
      gridArea: 'one'
    },
    '& > :nth-child(2)': {
      gridArea: 'two'
    },
    '& > :nth-child(3)': {
      gridArea: 'three'
    }
  }), facepaintMediaQueries({
    display: '-ms-grid',
    msGridColumns: ['1fr', "1fr " + GRID.xsmall + " 1fr", "1fr " + GRID.small + " 1fr " + GRID.small + " 1fr"],
    msGridRows: ['1fr', "1fr " + GRID.xsmall + " 1fr", '1fr'],
    '& > :nth-child(1)': {
      msGridColumn: 1,
      msGridColumnSpan: [1, prioritizeFirst ? 3 : 1, 1],
      msGridRow: 1
    },
    '& > :nth-child(2)': {
      msGridColumn: [1, prioritizeFirst ? 1 : 3, 3],
      msGridRow: [1, prioritizeFirst ? 3 : 1, 1]
    },
    '& > :nth-child(3)': {
      msGridColumn: [1, prioritizeFirst ? 3 : 1, 5],
      msGridColumnSpan: [1, prioritizeFirst ? 1 : 3, 1],
      msGridRow: [1, 3, 1]
    }
  })];
};

export var ThreeColumns = function ThreeColumns(_a) {
  var children = _a.children,
      _b = _a.prioritize,
      prioritize = _b === void 0 ? 'first' : _b;
  return jsx("div", {
    css: styles(prioritize)
  }, children);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Grid/ThreeColumns.js
// module id = 828
// module chunks = 0